import { useEffect, useState } from 'react'

export const useIsMobile = (breakpoint: number = 992) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint)

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`)

    const onChange = () => {
      setIsMobile(mql.matches)
    }

    mql.addEventListener('change', onChange)
    setIsMobile(mql.matches)

    return () => mql.removeEventListener('change', onChange)
  }, [breakpoint])

  return isMobile
}
